<script>
  import '$styles';
  import { onMount } from 'svelte';
  import { Seo, Footer, Header, Alert, Modal, Link, Leadfisher, Search } from '$client';
  import { phonePurify, phonePrettify, store } from '$client';
  import { afterNavigate } from '$app/navigation';
  export let data;

  $: ({ seo, bread, city, cities, other, footer, modals, header, contacts } = data);
  $: if (contacts?.phone) {
    afterNavigate(() => {
      const phone = contacts.phone;
      if (!phone) return () => {};
      const nodes = [...document.querySelectorAll('a[href^=tel]')];
      nodes.forEach(e => {
        e.setAttribute('href', `tel:${phonePurify(phone)}`);
        e.innerText = phonePrettify(phone);
      });
    });
  }

  $: store.city.set(city);
  $: store.cities.set(cities);
  $: store.other.set(other);

  onMount(() => {
    let alert = localStorage.getItem('cookieAlert');
    if(!alert) {
      setTimeout(() => {
        localStorage.setItem('cookieAlert', true)
        $: store.alert.set({
          header: 'Cookies',
          description: `Наш сайт использует файлы cookie, чтобы улучшить работу сайта, повысить его эффективность и удобство. Продолжая пользоваться  сайтом, вы соглашаетесь на обработку файлов Cookie на условиях, указанных <a>здесь</a>.`,
          button: 'Понятно',
        });
      }, 5000);
    }
  })
</script>

{#if seo && city}
  <Seo data={seo} />
{/if}

{#if other.promo && other.promo.data}
  <aside id="top-banner" class="container">
    {#if other.promo.url}
      <Link attributes={{ title: other.promo.data }} href={other.promo.url} />
    {/if}
    {other.promo.data}
  </aside>
{/if}

<Header {bread} data={header} />
<slot />
<Footer data={footer} />

<aside>
  {#if other.widget}
    <Leadfisher data={other.widget} />
  {/if}
  <Alert />
  <Search />
  <Modal data={modals} />
</aside>

<style lang="scss">
  #top-banner {
    position: relative;
    z-index: 5;
    height: 68px;
    max-height: 68px;
    padding: 20px;
    overflow-x: auto;
    color: rgb(44 51 60);
    font-weight: 500;
    font-size: 20px;
    font-family: Vela Sans;
    font-style: normal;
    line-height: normal;
    white-space: nowrap;
    text-align: center;
    word-wrap: none;
    background: #efefef;

    @media only screen and (max-width: 380px) {
      font-size: 18px;
    }

    :global(a) {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
</style>
